import React from 'react';

import { PLAYLIST_STATUS } from '@content-playlist-creation/common/constants';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import * as playlistsApi from '../../api/playlists';
import * as sharedFoldersApi from '../../api/shared-folders';
import PlaylistCard from '../../components/playlist/PlaylistCard';
import Collection from '../../components/search/Collection';
import FolderCard from '../../components/sharedFolder/FolderCard';
import GlobalContext from '../../contexts/GlobalContext';
import { isSharedFolderUser } from '../../utils/auth';

const DEFAULT_PAGE = 1;
const DEFAULT_SUBMITTED_PLAYLISTS_LIMIT = 100;
const DEFAULT_APPROVED_PLAYLIST_LIMIT = 100;
const FOLDERS_LIMIT = 100;

class ContentCreatorDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			folders: [],
			submittedPlaylists: [],
			approvedPlaylists: [],
		};

		this.fetchSubmittedPlaylists = this.fetchSubmittedPlaylists.bind(this);
		this.fetchApprovedPlaylists = this.fetchApprovedPlaylists.bind(this);
		this.fetchFolders = this.fetchFolders.bind(this);
	}

	componentDidMount() {
		const { loaderCallback } = this.props;

		this.fetchFolders();
		this.fetchSubmittedPlaylists(DEFAULT_SUBMITTED_PLAYLISTS_LIMIT, DEFAULT_PAGE);
		this.fetchApprovedPlaylists(DEFAULT_APPROVED_PLAYLIST_LIMIT, DEFAULT_PAGE);
		loaderCallback();
	}

	async fetchSubmittedPlaylists(limit, page) {
		const response = await playlistsApi.getPlaylists({
			status: [PLAYLIST_STATUS.SUBMITTED],
			limit,
			page,
			includeThumbnails: true,
			playlistTypeFilter: -1, // all types
		});

		this.setState({
			submittedPlaylists: response.data,
		});
	}

	async fetchApprovedPlaylists(limit, page) {
		const response = await playlistsApi.getPlaylists({
			status: [PLAYLIST_STATUS.APPROVED],
			limit,
			page,
			includeThumbnails: true,
			playlistTypeFilter: -1, // all types
		});

		this.setState({
			approvedPlaylists: response.data,
		});
	}

	async fetchFolders() {
		if (isSharedFolderUser()) {
			const folders = await sharedFoldersApi.getFolders(FOLDERS_LIMIT, 1);

			this.setState({
				folders: folders.data,
			});
		}
	}

	render() {
		const { folders, approvedPlaylists, submittedPlaylists } = this.state;

		return (
			<div className='w-100 d-block'>
				{isSharedFolderUser() && (
					<>
						<Collection
							header='Catalog Folders'
							seeAllLink='/folders'
							enableCarousel
							showHeaderUnderline
							itemsPerRow={4}
							largeCollection
						>
							{(folders || []).map(folder => (
								<FolderCard
									className='dashboard__collection__folder-card'
									title={folder.name}
									folderID={folder.shared_folder_id}
									coverImages={folder.cover_thumbnail_images || folder.cover_images}
									key={folder.shared_folder_id}
									numSongs={folder.num_songs}
									isDeleted={!!folder.deleted_timestamp}
									totalViewers={folder.total_folder_viewers}
									totalCreators={folder.total_folder_creator_shares}
								/>
							))}
						</Collection>
						<br />
					</>
				)}
				<Collection
					header='Playlists waiting approval'
					seeAllLink='/playlists/pending'
					enableCarousel
					showHeaderUnderline
					itemsPerRow={4}
					largeCollection
				>
					{(submittedPlaylists || []).map(playlist => (
						<PlaylistCard
							className='dashboard__collection__playlist-card'
							title={playlist.name}
							playlistId={playlist.playlist_id}
							statusId={playlist.playlist_status_id}
							coverImages={playlist.cover_thumbnail_images || playlist.cover_images}
							flagged={playlist.playlist_status_id === PLAYLIST_STATUS.INVALID}
							key={playlist.playlist_id}
							numSongs={playlist.num_songs}
							notes={playlist.notes}
						/>
					))}
				</Collection>
				<br />
				<Collection
					header='Approved Playlists'
					seeAllLink='/playlists/approved'
					enableCarousel
					showHeaderUnderline
					itemsPerRow={4}
					largeCollection
				>
					{(approvedPlaylists || []).map(playlist => (
						<PlaylistCard
							className='dashboard__collection__playlist-card'
							title={playlist.name}
							playlistId={playlist.playlist_id}
							statusId={playlist.playlist_status_id}
							coverImages={playlist.cover_thumbnail_images || playlist.cover_images}
							flagged={playlist.playlist_status_id === PLAYLIST_STATUS.INVALID}
							key={playlist.playlist_id}
							numSongs={playlist.num_songs}
							inAirtable={
								PLAYLIST_STATUS.APPROVED === playlist.playlist_status_id &&
								!!playlist.airtable_version &&
								playlist.airtable_version === playlist.current_version
							}
							notes={playlist.notes}
						/>
					))}
				</Collection>
			</div>
		);
	}
}

ContentCreatorDashboard.propTypes = {
	loaderCallback: PropTypes.func.isRequired,
};

ContentCreatorDashboard.contextType = GlobalContext;

export default withRouter(ContentCreatorDashboard);
